import React, { useEffect, useState } from 'react'
import { Flex, Box } from 'reflexbox'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import moment from 'moment'
import { Link } from 'react-router-dom'

import DataListingTable from 'components/DataListingTable'
import Button from 'components/Button'
import { Title, Text } from 'components/Typography'
import { DateRangePickerField } from 'components/Form/Fields'

import { getOrdersHistory } from 'services/orders'

const tableColumns = [
  {
    Header: 'Pedido',
    accessor: 'id',
  },
  {
    Header: 'Parceiro',
    accessor: 'partner',
  },
  {
    Header: 'Pacotes',
    accessor: 'items',
  },
  {
    Header: 'Total do pedido',
    accessor: 'amount',
  },
  {
    Header: 'Data da compra',
    accessor: 'purchase_date',
  },
  {
    Header: 'Status do Pagamento',
    accessor: 'status',
  },
]

const initialValues = {
  date: {
    startDate: '',
    endDate: '',
  },
}

const getOrderPaymentStatus = order => {
  if (order?.payment_type === 'no-payment') {
    return 'Crédito'
  }

  if (order?.is_payment_confirmed) {
    return 'Confirmado'
  }

  return 'Pendente'
}

const formatTableData = data => {
  return data.map(item => ({
    id: (
      <Text as={Link} to={`/staff/prepaid-partners/purchase-history/orders/${item.id}`}>
        {item.id}
      </Text>
    ),
    partner: item.partner.company_name ? item.partner.company_name : '',
    items: item.items ? item.items.map(({ package_name }) => package_name).toString() : '-',
    amount: item.amount ? `R$ ${item.amount}` : '-',
    status: getOrderPaymentStatus(item),
    purchase_date: item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '-',
  }))
}

const PurchaseHistory = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [tableData, setTableData] = useState([])
  const [filter, setFilter] = useState({})
  const [sortBy, setSortBy] = useState(null)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecords: 0,
  })

  const handleTableDataFetch = ({ sortBy, currentPage, pageSize }) => {
    setSortBy(sortBy)
    setPagination({ ...pagination, currentPage, pageSize })
  }

  const handleSubmit = ({ date }) =>
    setFilter({
      ...(date && date.startDate && { start_date: moment(date.startDate._d).format('YYYYMMDD') }),
      ...(date && date.endDate && { end_date: moment(date.endDate._d).format('YYYYMMDD') }),
    })

  useEffect(() => {
    const getPurchases = async () => {
      try {
        setIsLoading(true)
        const res = await getOrdersHistory({ pagination, sortBy, ...filter })
        setTableData(formatTableData(res.history))
        setPagination(res.pagination)
      } catch (e) {
        console.log(e)
        toast.error('Erro ao carregar histórico de compras.')
      } finally {
        setIsLoading(false)
      }
    }

    if (sortBy) {
      getPurchases()
    }
  }, [pagination.currentPage, pagination.pageSize, sortBy, filter])

  return (
    <Flex flexDirection='column'>
      <Box alignItems='center' width={1} mb={32}>
        <Title as='h3'>Histórico de compras</Title>
      </Box>
      <Formik onSubmit={handleSubmit} initialValues={initialValues}>
        <Form>
          <Flex justifyContent='flex-start' alignItems='center' mb={32}>
            <DateRangePickerField name='date' placeholder='Data' mr={32} />
            <Button variant='secondary' type='submit'>
              Filtrar
            </Button>
          </Flex>
        </Form>
      </Formik>
      <DataListingTable
        columns={tableColumns}
        data={tableData}
        pagination={pagination}
        loading={isLoading}
        fetchData={handleTableDataFetch}
      />
    </Flex>
  )
}

export default PurchaseHistory
